module.exports = __webpack_public_path__ + "media/images/replay_10_black_24dp-89a5ba1fb21c7738cbb882e5ae49a2cd.svg";